import { render, staticRenderFns } from "./Citime.vue?vue&type=template&id=38cce82a&scoped=true"
import script from "./Citime.vue?vue&type=script&lang=js"
export * from "./Citime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cce82a",
  null
  
)

export default component.exports